import classNames from 'classnames';
import { Button, Modal } from '@mui/material';
import accordionStyles from '../traffic-info-accordion.module.scss';
import { TRAFFIC_INFO_LEGEND_ITEMS, TrafficInfoLegendItem } from './traffic-info-legend-data';
import styles from './traffic-info-legend-modal.module.scss';
import { ReactComponent as IconClose } from '../../../../assets/icons/icon-close.svg';

export interface TrafficInfoLegendModalProps {
  open: boolean;
  onClose: () => void;
}

const LegendRow = ({ item }: { item: TrafficInfoLegendItem }): JSX.Element => (
  <div className={styles.Row}>
    <div className={classNames(accordionStyles.TrafficInfoAccordionTag, styles.Badge, item.className)}>
      {item.badge}
    </div>
    <span className={styles.Label}>{item.label}</span>
  </div>
);

export const TrafficInfoLegendModal = ({ open, onClose }: TrafficInfoLegendModalProps): JSX.Element => {
  document.body.classList.remove('modalOpen');
  document.body.classList.remove('modalWarningOpen');

  if (open) {
    document.body.classList.add('modalOpen');
  }

  return (
    <Modal
      className={styles.Modal}
      data-test-id="traffic-info-legend-modal"
      hideBackdrop={true}
      open={open}
      onClose={(_, reason): void => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
    >
      <div className={styles.ModalContent}>
        <Button className={styles.CloseButton} aria-label="Schließen" onClick={(): void => onClose()}>
          <IconClose />
        </Button>
        <h2 className={styles.Headline}>Verkehrsmittel</h2>
        <p className={styles.Intro}>Hier finden Sie eine Legende zu unseren Verkehrsmitteltypen.</p>
        <div className={styles.List}>
          {TRAFFIC_INFO_LEGEND_ITEMS.map((item) => (
            <LegendRow key={item.badge} item={item} />
          ))}
        </div>
      </div>
    </Modal>
  );
};
